import {IconNames} from '@blueprintjs/icons';

import {REPORT_TYPE} from '../models';
import {reportIcon} from './custom-icons';

export function typePathIcon(type: string | undefined, reportProps: {}): string | JSX.Element {
  switch(type) {
    case REPORT_TYPE.NOTEBOOK:
      return IconNames.MANUAL;
    case REPORT_TYPE.TABLEAU_EMBED:
      return IconNames.DASHBOARD;
    default:
      return reportIcon(reportProps);
  }
}
